<template>
  <div class="video-box">
    <!-- <div id="video" style="width:100%; height: 100%;"></div> -->
    <video-player
      style="width:100%; height: 100%;"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      :events="eventsArr"
      @fullscreenchange="fsc($event)"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
    >
    </video-player>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
export default {
  name: 'Video',

  mixins: [],

  components: {
    videoPlayer,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      eventsArr: ['fullscreenchange'],
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src: '',
          },
        ],
        poster: '',
        controlBar: {
          currentTimeDisplay: true, // 当前时间
          timeDivider: true, // 时间分割线
          durationDisplay: true, // 总时间
          progressControl: true, // 进度条
          remainingTimeDisplay: true, //
          customControlSpacer: true, //
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },

  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },

  watch: {
    src(url) {
      if (url) this.initVideo();
    },
  },

  created() {},

  mounted() {
    // videojs('videoPlayer', {
    //   controlBar: {
    //     currentTimeDisplay: true, // 当前时间
    //     timeDivider: true, // 时间分割线
    //     durationDisplay: true, // 总时间
    //     progressControl: true, // 进度条
    //     remainingTimeDisplay: true, //
    //     customControlSpacer: true, //
    //     fullscreenToggle: true, // 全屏按钮
    //     volumePanel: false

    //   },
    // })
    this.initVideo();
  },

  destroyed() {},

  methods: {
    // listen event
    onPlayerPlay() {
      this.$emit('play');
    },
    onPlayerPause() {
      // console.log('player pause!', player)
    },
    fsc(player) {
      this.$emit('fullscreenchange', player);
    },
    msToTime(duration) {
      let milliseconds = parseInt((duration % 1000) / 100),
        seconds = parseInt((duration / 1000) % 60),
        minutes = parseInt((duration / (1000 * 60)) % 60),
        hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      return hours + ':' + minutes + ':' + seconds + '.' + milliseconds;
    },
    // ...player event

    // or listen state event
    playerStateChanged() {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied() {
      // you can use it to do something...
      // player.[methods]
    },
    initVideo() {
      this.playerOptions.sources[0].src = this.src;
      this.playerOptions.poster = this.img;

      // this.player = new window.TcPlayer('video', {
      //   mp4: this.src,
      //   autoplay: false,
      //   poster: this.img ||
      //     'https://img2.baidu.com/it/u=917476589,112161430&fm=26&fmt=auto',
      //   wording: {},
      //   listener: msg => {
      //     // event参考：
      //     // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#Media_Events
      //     this.$emit(msg.type, msg);
      //   },
      // });
    },
  },
};
</script>

<style lang="less" scoped>
.video-box {
  width: 100%;
  height: 160px;
  overflow: hidden;
  border-radius: 8px;
  & /deep/ .video-js {
    width: 100%;
    height: 100%;
    .vjs-big-play-button {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      font-size: 20px;
      top: 50%;
      left: 50%;
      line-height: 28px;
      transform: translate(-50%, -50%);
    }
    .vjs-poster {
      background-size: 100% 100%;
    }
  }
}
</style>
